import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background">
      <p
        className="text-[120px] font-black select-none"
        style={{ color: "var(--primary)", opacity: 0.08 }}
      >
        404
      </p>

      <div className="-mt-6">
        <h1
          className="text-2xl font-bold mb-2"
          style={{ color: "var(--primary)" }}
        >
          Page not found
        </h1>
        <p className="text-muted-foreground text-sm max-w-sm mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="h-10 px-5 rounded-lg text-sm font-medium text-primary-foreground transition hover:opacity-90 inline-flex items-center"
            style={{ backgroundColor: "var(--primary)" }}
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
